import type { EnrichmentStats, StatsRange } from '../../_shared/domain/stats.domain';

/**
 * Redux state for the Metrics page. `loading` covers a load with nothing to show
 * for the requested period (the page shows skeletons); `fetching` is any request
 * in flight, the background poll included (a subtle spinner); `error` is set only
 * when a load fails with no stats to fall back on.
 */
export interface MetricsState {
  stats: EnrichmentStats | null;
  /**
   * The period the current load asks for. `stats` may still hold the previous
   * period's figures while it runs; the page keeps them on screen rather than
   * flashing skeletons on every preset change.
   */
  range: StatsRange | null;
  loading: boolean;
  fetching: boolean;
  error: boolean;
}

export const initialState: MetricsState = {
  stats: null,
  range: null,
  loading: false,
  fetching: false,
  error: false,
};
